import { ReleaseNoteCategory } from "@/openapi/generated";
import { formatRelativeDate, formatShortDate } from "@/lib/utils/date";

export { formatRelativeDate, formatShortDate };
export { truncateText, formatImportance } from "@donista/shared/utils/release-notes";

export function getImportanceDescription(importance: number): string {
  switch (importance) {
    case 5: return "Kritisch";
    case 4: return "Hoch";
    case 3: return "Mittel";
    case 2: return "Niedrig";
    case 1: return "Info";
    default: return "Unbewertet";
  }
}

export function formatCategoryName(category: ReleaseNoteCategory): string {
  const categoryMap: Record<ReleaseNoteCategory, string> = {
    [ReleaseNoteCategory.FEATURE]: 'Neue Funktion',
    [ReleaseNoteCategory.IMPROVEMENT]: 'Verbesserung',
    [ReleaseNoteCategory.BUGFIX]: 'Fehlerbehebung',
    [ReleaseNoteCategory.BREAKING_CHANGE]: 'Breaking Change',
  };

  return categoryMap[category] || 'Unbekannt';
}